import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";

import { dirname } from "../../../util/resourcePath";

import TargetViewContent from "./TargetTable/TargetViewContent";
import EmptyPage from "../../general/EmptyPage";

const TargetView = (props) => {
	const [selectedSite, setSelectedSite] = useState(null);
	const [reload, setReload] = useState(true);

	const directory = dirname();

	useEffect(() => {
		if (
			(selectedSite == null && props.selectedSite != null) ||
			(props.selectedSite != null &&
				selectedSite != null &&
				props.selectedSite != null &&
				selectedSite.site_id != props.selectedSite.value.site_id)
		)
			setSelectedSite(props.selectedSite.value);
	}, [props.selectedSite]);

	useEffect(() => {
		if (selectedSite != null && !reload) setReload(true);
	}, [selectedSite]);

	return (
		<div className="perf-table panel panel-default">
			<div className="panel-heading ">
				<Row>
					<Col md="6">
						<h2 className="panel-title">
							<span
								className="glyphicon glyphicon-screenshot"
								aria-hidden="true"
							></span>{" "}
							Target Table -{" "}
							{selectedSite != null ? selectedSite.site_name : ""}
						</h2>
					</Col>
					<Col md="6">
						<img
							src={`${directory}/images/reload.png`}
							onClick={() => {
								setReload(true);
							}}
							style={{
								height: "35px",
								cursor: "pointer",
								float: "right",
							}}
							alt="logo"
						/>
					</Col>
				</Row>
			</div>
			{selectedSite != null ? (
				<TargetViewContent
					selectedSite={selectedSite}
					reload={reload}
					setReload={setReload}
				/>
			) : (
				<EmptyPage message={"No site selected"} />
			)}
		</div>
	);
};

export default TargetView;
